export class UnitOwnerSimulateTokenGetRequest {
  unitId!: string
  constructor(unitId: string) { this.unitId = unitId }
}

export class UnitOwnerSimulateTokenGetResponse {
  oneTimeToken!: string
}
